import {ElementRef, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Root} from '../model/vehiclemodel/Root';

import {Observable, of} from 'rxjs';
import {DisclosureComponent} from "../tooltip/disclosure/disclosure.component";
import {MatDialog} from "@angular/material/dialog";
import {Overlay} from "@angular/cdk/overlay";
import {RootObject} from "../model/slicemodel/RootObject";
import {PostalCodeObject} from "../model/postalcodemodel/PostalCodeObject";
import {ConfigService} from "./config.service";
import {AppConfigService} from '../config/app-config.service';
import {Qauth} from "../model/configmodel/qauth";
import {catchError} from "rxjs/operators";
import {PaymentEstimatorResponse} from "../model/paymentEstimatorResponseModel/paymentEstimatorResponse";
import {PaymentEstimatorRequest} from "../model/paymentEstimatorRequestModel/PaymentEstimatorRequest";
import {LogService} from './LogService';

interface DefaultMonthlyPaymentParams {
	modelSlice: any;
	dnd: any;
	amount: any;
	planCode: any;
	isInclude: any;
	deposit: any;
	userRate: any;
	term: any;
	isDefault: any;
	amountFinanced: any;
	milesOrKMPerAnnum: any;
	zipCode: any;
	stateProvinceCode: any;
	tradeIn: any;
}

@Injectable({
	providedIn: 'root'
})
export class VehicleModelService {
	root: Root;
	authTokenData:Qauth
	private errorMsg: string;
	environment : any;
	mpUrl: string;
	baseUrl: string


	constructor(private readonly httpClient: HttpClient, private readonly dialog: MatDialog, private readonly overlay: Overlay, private readonly configService: ConfigService, private readonly appConfigService: AppConfigService, private readonly logService:  LogService) {
		this.environment = this.appConfigService.getBaseEndpoint();
		this.mpUrl = this.environment.calculatePaymentCall;
		this.baseUrl = this.environment.digUrl;
	}

	getImage(imageUrl) {
		return this.httpClient.get(imageUrl, {responseType: 'blob'});
	}
	getImageUrlWithOutToken(model: string, year: string) {
		return this.baseUrl + '/Lincoln/' + model + '/' + year + '/HD-TILE/Hero/EXT/4/vehicle.png'
	}

	digUrl(token: any, profile: any, view: any, angle: any) {
		if (token) {
			const p = token.indexOf('Image[|');
			let t;
			if (p === 0) {
				t = token.split('|').splice(1);
				if (t.length > 3) {
					return this.baseUrl + '/' + [
						t[0],
						t[1],
						t[2],
						profile,
						encodeURIComponent(token),
						view,
						angle,
						'vehicle.png'
					].join('/');
				}
			}
		}
		return null;
	}

	getToolTipMsrp($event: MouseEvent, val: string, vehList: ElementRef) {
		if (val.includes('sliceMsrp') === false) {
			$event.stopPropagation();
		}
		const myElementRef = vehList;
		const dialogRef = this.dialog.open(DisclosureComponent, {
			data: {
				positionRelativeToElement: myElementRef, val, $event
			},
			panelClass: 'custom-dialog-container',
			scrollStrategy: this.overlay.scrollStrategies.reposition(),

		});
		dialogRef.afterClosed()
			.subscribe(_res => {
				this.logService.debug('Dialog closed with result', _res);
			});
	}
	getDefaultMonthlyPayment({modelSlice, dnd, amount, planCode, isInclude, deposit, userRate, term, isDefault, amountFinanced, milesOrKMPerAnnum, zipCode, stateProvinceCode, tradeIn}: DefaultMonthlyPaymentParams) {

		const body: PaymentEstimatorRequest = {
			accessedFrom: "LINCOLN-PE",
			geoInfo: {
				country: "US",
				zipPostalCode: String(zipCode),
				stateProvinceCode
			},
			vehicle: {
				catalog: {
					make: 'Lincoln',
					model: modelSlice.make,
					displayModelName: 'Lincoln ' + modelSlice.make,
					trim: modelSlice.name,
					year: modelSlice.year
				},
				tradeInVehicle: {
					tradeAllowance: Number(tradeIn)
				},
				price: {
					deposit: Number(deposit)
				}
			},
			financial: {
				planCode: Number(planCode),
				term,
				usersRate: Number(userRate),
				incentives: []
			}
		}
		if (Number(planCode) === 2) {
			body.financial.milesOrKmPerAnnum = Number(milesOrKMPerAnnum);
		}

		let headers
		headers = {
			'Content-Type': 'application/json',
			'Access-Control-Request-Method': 'POST',
		};

		return this.httpClient.post<PaymentEstimatorResponse>(this.mpUrl, JSON.stringify(body), {headers}).pipe(
			catchError(error => {
				if (error.error instanceof ErrorEvent) {
					this.errorMsg = `Error: ${error.error.message}`;
				} else {
					this.errorMsg = `Error: ${error.message}`;
				}
				return of([]);
			})
		);;

	}

	getPostalCodeData(postalCode) {
		const headers = {
			'application-id': this.environment.applicationId
		};
		let params = new HttpParams();
		params = params.append('postalCode', postalCode);
		const url = this.configService.getAppConfigValue().zipCodeUrl + params;
		return this.httpClient.get<PostalCodeObject>(url, {headers})
	}

	validateZipCode(baseURL1, model, year, postalCode) {
		const headers = {
			'application-id': this.environment.applicationId
		};
		let params = new HttpParams();
		params = params.append('model', model);
		params = params.append('year', year);
		params = params.append('postalCode', postalCode);

		const modelSliceURL = baseURL1 + params;
		return this.httpClient.get<RootObject>(modelSliceURL, {headers})
	}

	getAllModelSlice(year, model, baseURL1): Observable<RootObject> {
		return this.validateZipCode(baseURL1, model, year, '48120');
	}
}
